import { OwnershipState } from './state';

export const ownershipInitialState: OwnershipState = {
  assets: {},
  updateStatus: 'initial',
  userOwnerships: undefined,
};
